module.exports = __webpack_public_path__ + "img/banner01.1bff139b.png";